import { StandardForm, FormField, FormLabel, SearchInput, Button, Spinner } from '@vp/swan';
import React, { useEffect } from 'react';
import { useStorageState, LocalStorageProvider } from '@vp/digital-storage-lib-ubik';

var SearchComponent = function (_a) {
    var _b, _c, _d, _e;
    var className = _a.className, contentBeforeCTA = _a.contentBeforeCTA, ctaProps = _a.ctaProps, inputProps = _a.inputProps, _f = _a.disabled, disabled = _f === void 0 ? false : _f;
    var _g = React.useState((_b = inputProps === null || inputProps === void 0 ? void 0 : inputProps.value) !== null && _b !== void 0 ? _b : ''), domain = _g[0], setDomain = _g[1];
    useEffect(function () {
        if (inputProps === null || inputProps === void 0 ? void 0 : inputProps.value)
            setDomain(inputProps === null || inputProps === void 0 ? void 0 : inputProps.value);
    }, [inputProps === null || inputProps === void 0 ? void 0 : inputProps.value]);
    var forceOnClickHandler = typeof (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.forceOnClickHandler) === 'undefined'
        ? true
        : ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.forceOnClickHandler;
    var onSubmit = function (event) {
        event.preventDefault();
        (inputProps === null || inputProps === void 0 ? void 0 : inputProps.setValue) && (inputProps === null || inputProps === void 0 ? void 0 : inputProps.setValue(domain));
        if (forceOnClickHandler)
            (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.onClickHandler) && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.onClickHandler(domain));
        return false;
    };
    return (React.createElement(StandardForm, null,
        React.createElement(FormField, { className: className !== null && className !== void 0 ? className : '', standardMode: true },
            React.createElement(FormLabel, { visuallyHidden: true }, "Search"),
            React.createElement(SearchInput, { "aria-label": (_c = inputProps.ariaLabel) !== null && _c !== void 0 ? _c : 'search', disabled: disabled, placeholder: inputProps.textInputPlaceholder, accessibleTextForClearButton: "Clear", accessibleTextForSearchButton: "Search", skin: (_d = inputProps.skin) !== null && _d !== void 0 ? _d : 'standard', value: domain, onChange: function (event) {
                    if (inputProps.onChangeHandler)
                        inputProps.onChangeHandler(event.target.value);
                    setDomain(event.target.value);
                }, onSearchSubmit: function (event) { return onSubmit(event); }, id: "digital-search-component-text-input" }),
            contentBeforeCTA,
            ctaProps && ctaProps.textCTA && (React.createElement(Button, { skin: "primary", type: "submit", disabled: disabled, mt: '4', onClick: function (event) {
                    (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.onClickHandler) && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.onClickHandler(domain));
                } }, disabled ? (React.createElement(React.Fragment, null,
                React.createElement(Spinner, { accessibleText: "Loading..." }),
                ' ', (_e = ctaProps.loadingText) !== null && _e !== void 0 ? _e : '')) : (React.createElement(React.Fragment, null, ctaProps.textCTA)))))));
};

var WIX_DOMAINS_SEARCHED_DOMAIN_KEY = 'wix-domains-searched-domain';
var useSearchedDomainValue = function (initialValue) {
    var _a = useStorageState(WIX_DOMAINS_SEARCHED_DOMAIN_KEY, initialValue, new LocalStorageProvider()), searchedValue = _a[0], setSearchedValue = _a[1], resetSearchedValue = _a[2];
    return [searchedValue, setSearchedValue, resetSearchedValue];
};

var WIX_DOMAINS_HAS_OWN_DOMAIN_KEY = 'wix-domains-has-own-domain';
var useHasOwnDomainValue = function (initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var _a = useStorageState(WIX_DOMAINS_HAS_OWN_DOMAIN_KEY, initialValue, new LocalStorageProvider()), hasOwnDomainValue = _a[0], setHasOwnDomainValue = _a[1], resetHasOwnDomainValue = _a[2];
    return [hasOwnDomainValue, setHasOwnDomainValue, resetHasOwnDomainValue];
};

export { SearchComponent, useHasOwnDomainValue, useSearchedDomainValue };
